<template>
  <div class="statuts-wrap pt-20 pb-20">
    <div class="container mx-auto px-6">

      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Statuts et Règlements
      </h2>

      <!-- Normes générales -->
      <div class="content-text mb-6">
        <h3 class="text-xl font-semibold text-primary mb-2">Normes générales</h3>
        <p>
          « Tout ce qui est vrai et noble, tout ce qui est juste et pur, tout ce qui est digne d’être aimé et honoré, tout ce qui s’appelle vertu et qui mérite des éloges, tout cela, prenez-le en compte » (Ph 4,8).
        </p>
        <p>
          Une bonne tenue (non usage du téléphone portable en cours, témoignage chrétien convenable) au cours, durant les devoirs ou examens et à l’école est signe de respect de soi et de charité envers les autres.
        </p>
      </div>

      <!-- Nature de la formation et des apprenants -->
      <div class="content-text mb-6">
        <h3 class="text-xl font-semibold text-primary mb-2">1) La nature de la formation et des apprenants</h3>

        <h5 class="fw-semibold text-primary mt-2">a) De la formation à l’EITP</h5>
        <p>
          La formation à l’EITP est une initiation. Elle vise à communiquer des aptitudes à la réflexion théologique et pastorale. Les cours sont validés par étapes : présence régulière, devoirs/examens, et enfin examen final, travail de recherche et participation au pèlerinage.
        </p>

        <h5 class="fw-semibold text-primary mt-2">b) Des caractéristiques des apprenants</h5>
        <ul>
          <li><strong>Auditeurs :</strong> Suivent les cours librement. Présence nécessaire, mais pas de devoirs/examens. Reçoivent une attestation pour modules suivis.</li>
          <li><strong>Habitués :</strong> Auditeurs ayant validé certains modules par devoirs. Reçoivent un certificat de participation.</li>
          <li><strong>Disciples :</strong> Suivent toute la formation et valident tous les modules (présence + devoirs + examen final). À la fin de la 2ème année, ils passent un Examen Général (écrit et éventuellement oral) et rédigent un texte de 20 à 25 pages avec accompagnement.
          </li>
        </ul>
      </div>

      <!-- Axes de validation -->
      <div class="content-text mb-6">
        <h3 class="text-xl font-semibold text-primary mb-2">2) Les divers axes de validation</h3>

        <h5 class="fw-semibold text-primary mt-2">a) Validation par la présence</h5>
        <ul>
          <li>Modules de 7/8 séances : minimum 5 séances pour valider ; rattrapage possible de 2 séances si 4 suivies.</li>
          <li>Modules de 6 séances : minimum 4 séances ; rattrapage possible de 2 séances si 3 manquées.</li>
          <li>Modules de 4/3 séances : minimum 2 séances ; une seule séance nécessite reprise du cours.</li>
          <li>Gestion des absences possible en suivant le même cours dans un autre groupe, avec information au secrétariat.</li>
          <li>Cours particuliers de rattrapage possibles, payants.</li>
        </ul>

        <h5 class="fw-semibold text-primary mt-2">b) Validation par les devoirs</h5>
        <ul>
          <li>Modules de Bible et Théologie : devoirs de recherche individuels ou en groupe et/ou DST.</li>
          <li>Modules d’Histoire : devoirs de recherche individuels ou en groupe.</li>
          <li>Modules de Morale et Liturgie : QCM ou questions-réponses.</li>
          <li>Modules de Culture Générale : travaux de groupe ou épreuves orales en groupe.</li>
          <li>Modules de Spiritualité ou Droit Canon : pas d’évaluation.</li>
        </ul>

        <h5 class="fw-semibold text-primary mt-2">Autres normes</h5>
        <ul>
          <li>Achèvement de l’initiation : maximum trois ans, exceptionnellement quatre ans.</li>
          <li>Abandon sans raison pendant trois mois : reprise obligatoire de l’année.</li>
          <li>Inscription en 2ème année liée à la validation du statut d’auditeur.</li>
          <li>Rattrapages durant la même année : pas de frais supplémentaires ; après l’année : frais déterminés au début de l’année.</li>
        </ul>

        <p class="mt-3"><em>Serva ordinem et ordo servabit te. (Sers l’ordre et l’ordre te servira.)</em></p>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "StaTut",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.statuts-wrap {
  background-color: #fff;
}

h2 {
  color: #2b3a67;
}

.content-text h3 {
  color: #2b3a67;
  font-weight: 600;
}

.content-text h5 {
  color: #2b3a67;
  font-weight: 500;
  margin-top: 1rem;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}

.content-text ul ul {
  list-style-type: circle;
  margin-top: 0.5rem;
}
</style>
